/** Removes all duplicates from an array of objects
 * @param { T[] }
 * @returns { T[] }
 */
export const unique = <T>(array: T[]): T[] =>
  [...new Set(array.map((o) => JSON.stringify(o)))].map((s) => JSON.parse(s))
